export default "__VITE_ASSET__CLyaNO$o__"